//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Icon } from "@iconify/vue2";
import { formatPrice } from "~/utils/discount";

export default {
  name: "PaymentOptions",
  components: { Icon },
  props: {
    selectedPayment: {
      type: String,
      default: "",
    },
    showStatusScreen: {
      type: Boolean,
      default: false,
    },
    priceUSD: Number,
    pricePesos: Number,
    shortName: String,
  },
  computed: {
    discountedPricePesos() {
      return this.pricePesos;
    },
    discountedPriceUSD() {
      return this.priceUSD;
    }
  },
  methods: {
    formatPrice,
  }
};
